import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["modal", "bottom", "top", "list", "view", "mainCard", "bodyTable", "footerTable",
                    "body","searchInput", "searchTable"]

  connect() {
    this.controllerName = `operations--products--accounts--products--modal`
    this.controllerNumber = this.getControllerByIdentifier(`app--helpers--numbers`)
    this.itemsOnPage = 500
    this.pageNumber = 0
    this.numberPages = []
    this.tableCols = 8
    this.sort = { mode: `asc`, field: `name` }
  }

  open() {
    document.body.classList.add("modal-open");
    this.element.setAttribute("style", "display: block;");
    this.element.classList.add("show");
    const html = `<div class="modal-backdrop fade show"></div>`
    // document.body.insertAdjacentHTML("beforeend", html)
    var controller = this
    new Promise(function (resolve) {
      resolve(document.body.insertAdjacentHTML("beforeend", html))
    }).then(() => {
      controller.doIndexListHtml()
    })
  }

  close() {
    this.stopSpin()
    document.body.classList.remove("modal-open");
    this.element.removeAttribute("style");
    this.element.classList.remove("show");
    document.getElementsByClassName("modal-backdrop")[0].remove();
    this.modalTarget.remove()
  }

  sortTable(ev) {
    var mode = ev.currentTarget.dataset.mode
    var field = ev.currentTarget.dataset.field

    if (mode == `desc`) {
      ev.currentTarget.nextElementSibling.classList.remove("d-none")
      ev.currentTarget.classList.add("d-none")
    } else if (mode == `asc`) {
      ev.currentTarget.previousElementSibling.classList.remove("d-none")
      ev.currentTarget.classList.add("d-none")
    }

    this.sort.mode = mode
    this.sort.field = field
    this.doDataTable()
  }

  doIndexListHtml() {
    var closeBtnHtml = `<span class="mc-tooltip">
                          <button aria-expanded="false" aria-haspopup="true" class="btn btn-outline my-0" data-action="click->${this.controllerName}#close" type="button">
                            <span class="material-icons md-dark">clear</span>
                          </button>
                          <span class="mc-tooltiptext">Fechar</span>
                        </span>`

    var refreshBtnHtml = `<span class="mc-tooltip">
                              <button aria-expanded="false" aria-haspopup="true" class="btn btn-outline my-0" data-${this.controllerName}-target="refreshAccountBtn" data-action="click->${this.controllerName}#getAccounts" type="button">
                                <span class="material-icons md-dark">refresh</span>
                              </button>
                              <span class="mc-tooltiptext">Atualizar Clientes</span>
                            </span>`

    var html = `<div class="card" style="width:100%;display:relative;" data-controller="app--helpers--search" data-${this.controllerName}-target="mainCard" data-action="resize@window->${this.controllerName}#layout">
                  <div class="card-header d-flex align-items-center card-header-table-list f-065">
                    <h6 class="card-title display-4 card-title-table-list">Clientes</h6>
                    <input class="form-control f-070 w-50 mx-auto" data-app--helpers--search-target="searchInput" data-${this.controllerName}-target="searchInput" data-action="keyup->app--helpers--search#doSearchTable keyup->${this.controllerName}#enterCloseModal" placeholder="Buscar ..." type="text">
                    <div class="card-actions ml-auto py-0">
                      ${refreshBtnHtml}
                      ${closeBtnHtml}
                    </div>
                  </div>
                  <div class="card-body py-0" style="overflow:auto;">
                    <div class="row">
                      <div class="col p-0">
                        <table class="table table-sm table-hover" data-app--helpers--search-target="searchTable" data-${this.controllerName}-target="searchTable" style="font-size:80%;">
                          <thead>
                            <tr>
                              <th style="font-size:80%;" scope="col" class="p-1 table-25 align-middle pointer">
                                Nome
                                <span class="material-icons md-sm md-dark" data-action="click->${this.controllerName}#sortTable" data-field="account_name" data-mode="desc">south</span>
                                <span class="material-icons md-sm md-dark d-none" data-action="click->${this.controllerName}#sortTable" data-field="account_name" data-mode="asc">north</span>
                              </th>
                              <th style="font-size:80%;" scope="col" class="p-1 table-10 align-middle text-center">Planner</th>
                              <th style="font-size:80%;" scope="col" class="p-1 table-10 align-middle text-center">IRPF</th>
                              <th style="font-size:80%;" scope="col" class="p-1 table-10 align-middle text-center">Livro-Caixa</th>
                              <th style="font-size:80%;" scope="col" class="p-1 table-10 align-middle text-center">PJ Médica</th>
                              <th style="font-size:80%;" scope="col" class="p-1 table-10 align-middle text-center">DP</th>
                              <th style="font-size:80%;" scope="col" class="p-1 table-10 align-middle text-center">Gestão de Recebimentos</th>
                              <th style="font-size:80%;" scope="col" class="p-1 table-10 align-middle text-center">Faturamento</th>
                            </tr>
                          </thead>
                          <tbody data-${this.controllerName}-target="bodyTable">
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                  <div class="card-footer py-0" data-${this.controllerName}-target="footerTable">
                  </div>
                </div>`

    var controller = this
    new Promise(function (resolve) {
      resolve(controller.bodyTarget.innerHTML = html)
    }).then(() => {
      controller.mainCardTarget.style.height = ($(window).height() * 0.55) + "px"
      controller.bodyTableTarget.insertAdjacentHTML("beforeend", controller.getControllerByIdentifier("app--helpers--table").doTablePreloader(controller.tableCols, 10))
      controller.getAccounts()
    })
  }

  doDataTable() {
    var accounts = []

    this.product_accounts.forEach(element => {
      if (element.kind == this.kind) {
        accounts[accounts.length] = element
      }
    })

    var orderedAccounts = this.getControllerByIdentifier("app--helpers--data").sortByKeyAsc(accounts, `name`)

    if (orderedAccounts.length == 0) {
      var pagination = { itemsOnPage: 0, fromItem: 0, toItem: 0, totalItems: 0 }
      this.listData()
      this.doFooterTable(pagination)
    } else {
      var itemsOnPage = this.itemsOnPage
      var pageNumber = this.pageNumber
      var numberPages = this.numberPages
      var pages = []
      var itemLoop = Math.ceil(orderedAccounts.length / itemsOnPage)
      var x = 0
      var i = 1
      for (i; i < itemLoop + 1; i++) {
        var internPage = []
        for (x; x < itemsOnPage * i; x++) {
          if (orderedAccounts[x] !== undefined) {
            internPage[internPage.length] = orderedAccounts[x]
          }
        }
        pages[pages.length] = internPage
        numberPages[numberPages.length] = i - 1
      }

      var fromItem = itemsOnPage * pageNumber + 1
      var toItem = Math.min(itemsOnPage * (pageNumber + 1), (itemsOnPage * pageNumber) + pages[pageNumber].length)
      var pagination = { itemsOnPage: itemsOnPage, fromItem: fromItem, toItem: toItem, totalItems: orderedAccounts.length }
      this.listData(pages[pageNumber])
      this.doFooterTable(pagination)
    }
  }

  listData(data) {
    this.searchTableTarget.focus()

    this.bodyTableTarget.innerHTML = ""
    if (data == undefined || data == [] || data.length == 0) {
      var noData = `</tr>
                      <td colspan="8" class="p-3 align-middle text-center" style="font-size:100%;">
                        <span class="fa-stack fa-1x">
                          <i class="fas fa-list fa-stack-1x"></i>
                        </span>
                        <span class="f-075 align-middle">Não há Clientes</span>
                      </td>
                    </tr>`

      this.bodyTableTarget.innerHTML = noData
    } else {
      data.forEach(element => {
        this.bodyTableTarget.insertAdjacentHTML("beforeend", this.accountTablePartial(element, data.length))
      });
    }

  }

  accountTablePartial(element, length) {

    if (element.has_tax_return) {
      var returnIcon = `<span class="mc-tooltip">
                          <span class="material-icons md-sm md-success">done</span>
                          <span class="mc-tooltiptext">É Cliente</span>
                        </span>`
    } else {
      var returnIcon = `<span class="mc-tooltip">
                          <span class="material-icons md-sm md-danger">clear</span>
                          <span class="mc-tooltiptext">Não Tem</span>
                        </span>`
    }
    if (element.has_booking) {
      var bookingIcon = `<span class="mc-tooltip">
                          <span class="material-icons md-sm md-success">done</span>
                          <span class="mc-tooltiptext">É Cliente</span>
                        </span>`
    } else {
      var bookingIcon = `<span class="mc-tooltip">
                          <span class="material-icons md-sm md-danger">clear</span>
                          <span class="mc-tooltiptext">Não Tem</span>
                        </span>`
    }
    if (element.has_clinic) {
      var legalIcon = `<span class="mc-tooltip">
                          <span class="material-icons md-sm md-success">done</span>
                          <span class="mc-tooltiptext">É Cliente</span>
                        </span>`
    } else {
      var legalIcon = `<span class="mc-tooltip">
                          <span class="material-icons md-sm md-danger">clear</span>
                          <span class="mc-tooltiptext">Não Tem</span>
                        </span>`
    }
    if (element.has_billing) {
      var billingIcon = `<span class="mc-tooltip">
                          <span class="material-icons md-sm md-success">done</span>
                          <span class="mc-tooltiptext">É Cliente</span>
                        </span>`
    } else {
      var billingIcon = `<span class="mc-tooltip">
                          <span class="material-icons md-sm md-danger">clear</span>
                          <span class="mc-tooltiptext">Não Tem</span>
                        </span>`
    }
    if (element.has_receivement) {
      var receivementIcon = `<span class="mc-tooltip">
                          <span class="material-icons md-sm md-success">done</span>
                          <span class="mc-tooltiptext">É Cliente</span>
                        </span>`
    } else {
      var receivementIcon = `<span class="mc-tooltip">
                          <span class="material-icons md-sm md-danger">clear</span>
                          <span class="mc-tooltiptext">Não Tem</span>
                        </span>`
    }
    if (element.has_tax_filing) {
      var filingIcon = `<span class="mc-tooltip">
                          <span class="material-icons md-sm md-success">done</span>
                          <span class="mc-tooltiptext">É Cliente</span>
                        </span>`
    } else {
      var filingIcon = `<span class="mc-tooltip">
                          <span class="material-icons md-sm md-danger">clear</span>
                          <span class="mc-tooltiptext">Não Tem</span>
                        </span>`
    }
    if (element.has_banking) {
      var bankingIcon = `<span class="mc-tooltip">
                          <span class="material-icons md-sm md-success">done</span>
                          <span class="mc-tooltiptext">É Cliente</span>
                        </span>`
    } else {
      var bankingIcon = `<span class="mc-tooltip">
                          <span class="material-icons md-sm md-danger">clear</span>
                          <span class="mc-tooltiptext">Não Tem</span>
                        </span>`
    }
    if (element.has_payroll) {
      var payrollIcon = `<span class="mc-tooltip">
                          <span class="material-icons md-sm md-success">done</span>
                          <span class="mc-tooltiptext">É Cliente</span>
                        </span>`
    } else {
      var payrollIcon = `<span class="mc-tooltip">
                          <span class="material-icons md-sm md-danger">clear</span>
                          <span class="mc-tooltiptext">Não Tem</span>
                        </span>`
    }


    if (length == 1) {
      var tableRow = `<tr class="itemRow" data-id="${element.id}" style="height:50px;">`
    } else {
      var tableRow = `<tr class="itemRow" data-id="${element.id}">`
    }


    var rowHtml = `${tableRow}
                    <td style="font-size:80%;" scope="col" class="p-1 align-middle pointer" data-action="click->${this.controllerName}#closeModalEv">${element.account_name}</td>
                    <td style="font-size:80%;" scope="col" class="p-1 align-middle text-center">${returnIcon}</td>
                    <td style="font-size:80%;" scope="col" class="p-1 align-middle text-center">${filingIcon}</td>
                    <td style="font-size:80%;" scope="col" class="p-1 align-middle text-center">${bookingIcon}</td>
                    <td style="font-size:80%;" scope="col" class="p-1 align-middle text-center">${legalIcon}</td>
                    <td style="font-size:80%;" scope="col" class="p-1 align-middle text-center">${payrollIcon}</td>
                    <td style="font-size:80%;" scope="col" class="p-1 align-middle text-center">${receivementIcon}</td>
                    <td style="font-size:80%;" scope="col" class="p-1 align-middle text-center">${billingIcon}</td>
                  </tr>`

    return rowHtml
  }

  enterCloseModal(ev) {
    if (ev.type == "keyup" && ev.key == "Enter") {

      var table = this.searchTableTarget
      var tr = table.getElementsByTagName("tr")
      var accountIds = []
      var accountId = ``

      for (var i = 1; i < tr.length; i++) {
        if (tr[i].matches(`.filter-row`)) {
          accountIds[accountIds.length] = tr[i].dataset.id
          // accountId = tr[i].dataset.id
        }
      }

      if (accountIds.length) {
        this.closeModal(accountIds[0])
      }
    }
  }

  closeModalEv(ev) {
    var accountId = ev.currentTarget.closest(".itemRow").dataset.id

    this.closeModal(accountId)
  }

  closeModal(accountId) {
    var account = {}

    this.product_accounts.forEach(element => {
      if (element.id == accountId) {
        account = element
      }
    })

    this.inputElement.value = account.account_name
    this.inputElement.dataset.accountId = account.account_id

    this.getControllerByIdentifier("app--helpers--forms").floatingLabel()
    this.close()
  }

  getAccounts() {
    this.bodyTableTarget.innerHTML = this.getControllerByIdentifier("app--helpers--table").doTablePreloader(this.tableCols, 10)
    this.getControllerByIdentifier(`app--helpers--pre-modal`).openProcessModal({ message: `Carregando Lista de Clientes!` })

    const data = { account: { account: true }, current_user: { current_user_id: this.application.current_user.id, feature: this.feature } }
    const url = `/operations/accounts/products/list_with_accounts`
    const init = { method: "POST", credentials: "same-origin", headers: { "X-CSRF-Token": this.application.token, 'Content-Type': 'application/json' }, body: JSON.stringify(data) }
    var controller = this
    fetch(url, init)
      .then(response => response.json())
      .then(response => {
        controller.product_accounts = response.data.cln

        controller.doDataTable()
        controller.getControllerByIdentifier(`app--helpers--fetch-response`).finalResponse(response)
      })
      .catch(error => {
        controller.getControllerByIdentifier(`app--helpers--fetch-response`).catchError(error)
      })
  }

  itemsLength(ev) {
    this.itemsOnPage = ev.target.dataset.items
    this.pageNumber = 0
    this.numberPages = []
    this.doDataTable()
  }

  previousTablePage(ev) {
    if (this.numberPages.includes(this.pageNumber - 1)) {
      this.pageNumber -= 1
      this.doDataTable()
    }
  }

  nextTablePage(ev) {
    if (this.numberPages.includes(this.pageNumber + 1)) {
      this.pageNumber += 1
      this.doDataTable()
    }
  }

  doFooterTable(pagination) {
    var footerHtml = `<div class="row">
                        <div class="col-3 d-flex">
                          <div class="card-actions align-items-center justify-content-end py-0 f-065">
                            <span data-app--helpers--search-target="footerTable"></span>
                          </div>
                        </div>
                        <div class="col-9 px-0">
                          <div class="card-actions align-items-center justify-content-end py-0 f-065">
                            <span class="align-self-center mb-1 mx-1 text-muted">Itens por Página:</span>
                            <div class="dropdown">
                              <button aria-expanded="false" aria-haspopup="true" class="btn btn-outline dropdown-toggle f-065" data-toggle="dropdown" type="button">${this.controllerNumber.numberMask(pagination.itemsOnPage)}</button>
                              <div class="dropdown-menu dropdown-menu-right menu">
                                <span class="dropdown-item pointer" data-action="click->${this.controllerName}#itemsLength" data-items="300">300</span>
                                <span class="dropdown-item pointer" data-action="click->${this.controllerName}#itemsLength" data-items="750">750</span>
                                <span class="dropdown-item pointer" data-action="click->${this.controllerName}#itemsLength" data-items="1000">1.000</span>
                              </div>
                            </div>
                            <span class="align-self-center mb-1 mr-2 text-muted">${this.controllerNumber.numberMask(pagination.fromItem)}-${this.controllerNumber.numberMask(pagination.toItem)} de ${this.controllerNumber.numberMask(pagination.totalItems)}</span>
                            <a class="btn btn-outline py-0" data-action="click->${this.controllerName}#previousTablePage"><i class="material-icons md-sm">chevron_left</i></a>
                            <a class="btn btn-outline py-0" data-action="click->${this.controllerName}#nextTablePage"><i class="material-icons md-sm">chevron_right</i></a>
                          </div>
                        </div>
                      </div>`

    this.footerTableTarget.innerHTML = footerHtml
  }

  stopSpin() {
    if (this.spinTimer) {
      clearInterval(this.spinTimer)
    }
  }

  getControllerByIdentifier(identifier) {
    return this.application.controllers.find(controller => {
      return controller.context.identifier === identifier;
    });
  }

  nameTarget(target) {
    return this.targets.find(target)
  }
}